import {
  InfoTooltip as DSInfoTooltip,
  InfoTooltipProps,
  InfoTooltipPropsG4P,
} from "@dbn/omnichannel-design-system-g4p";
import { useFormatMessage } from "../../intl";

export function InfoTooltip(props: InfoTooltipProps | InfoTooltipPropsG4P) {
  const formatMessage = useFormatMessage();
  return (
    <DSInfoTooltip
      childrenAriaLabel={formatMessage("generic.tooltip.infoIcon.ariaLabel")}
      closeIconAriaLabel={formatMessage("generic.tooltip.closeIcon.ariaLabel")}
      {...props}
    />
  );
}
